import React from 'react';

import dayjs from 'dayjs';
import styled from 'styled-components';

import { CommunityIncentiveType } from 'types/incentives';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  font-family: var(--font-regular);
  color: var(--text-secondary);
  font-size: 12px;
  line-height: normal;
`;

const Date = styled.span`
  color: var(--text-primary);
  font-size: 14px;
`;

type Props = {
  item: CommunityIncentiveType;
};

const CommunityIncentivesTableIncentivesDate = ({ item }: Props) => {
  return (
    <Container>
      <Date>{dayjs(item.date).format('MMM DD, YYYY')}</Date>
      <span>by {item.created_by?.full_name || item.created_by?.email}</span>
    </Container>
  );
};

export default CommunityIncentivesTableIncentivesDate;
